import { createGlobalStyle } from '../theming';

export const ResetStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    overflow-wrap: anywhere;
  }
`;
